import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['versionModalVisible'] = false,
  action: Action,
): RootState['versionModalVisible'] {
  switch (action.type) {
    case 'VERSION_MODAL_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
